import Box from '@mui/material/Box'
import { BrowserView } from 'react-device-detect'
import Link from '@mui/material/Link'
import logo from '../../../../assets/images/jablotron-logo.png'
import user from '../../../../assets/images/user.png'
import useAppAuth from '../../../providers/AppAuthProvider/hooks/useAppAuth'
import useStyles from './styles/Header.styles'

const Header = () => {
    const classes = useStyles()
    const auth = useAppAuth()
    return (
        <Box position={'fixed'} className={classes.headerBox}>
            <Box className={classes.flex}>
                <Box className={classes.logo} padding={2}>
                    <Link href={process.env.REACT_APP_DASHBOARD_REDIRECT}>
                        <img src={logo} className={classes.image} alt='logo' />
                    </Link>
                </Box>
                <BrowserView>
                    <Box className={classes.userWrap} padding={3}>
                        <img src={user} className={classes.userWrapImg} alt='user' />
                        <Box className={classes.userWrapBox}>{auth.user?.email}</Box>
                    </Box>
                </BrowserView>
            </Box>
        </Box>
    )
}

export default Header
